import { render, staticRenderFns } from "./physical-package-list.vue?vue&type=template&id=db68c130&scoped=true"
import script from "./physical-package-list.vue?vue&type=script&lang=ts"
export * from "./physical-package-list.vue?vue&type=script&lang=ts"
import style0 from "./physical-package-list.vue?vue&type=style&index=0&id=db68c130&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db68c130",
  null
  
)

export default component.exports